import React from "react";

import { Footer } from "./footer/footer";
import { Header } from "./header/header";

import { StyledLayout, StyledMain, StyledContainer } from "./layout.style";

export const Layout = ({ children }: React.PropsWithChildren) => {
  return (
    <StyledLayout>
      <Header />

      <StyledMain>
        <StyledContainer>{children}</StyledContainer>
      </StyledMain>

      <Footer />
    </StyledLayout>
  );
};
